<app-form-pyramidal-pyramid-item
  [prefilledName]="pyramidName"
  [prefilledCategoryId]="pyramidItem.categoryId"
  [prefilledCategoryName]="pyramidItem.categoryName"
  [prefilledSubCategoryId]="pyramidItem.subCategoryId"
  [prefilledSubCategoryName]="pyramidItem.subCategoryName"
  [prefilledPercentages]="prefilledPercentages"
  [lockNameAndCategories]="true"
  (formValidityChanged)="onFormValidityChanged($event)">
</app-form-pyramidal-pyramid-item>
